import { useStore } from "@tanstack/react-store";
import { cloneElement } from "react";
import { UserInfoResponse } from "./api";
import { authStore } from "./store";

export function AuthProtected({ children }: { children: React.ReactNode }) {
	const { user, doLogin } = useStore(authStore);

	if (user) {
		return children;
	}

	return cloneElement(children as React.ReactElement<any>, {
		onClickCapture: (e: React.MouseEvent<HTMLDivElement>) => {
			e.preventDefault();
			e.stopPropagation();
			doLogin();
		},
	});
}

export function AuthHoc({
	children,
}: {
	children: ({
		user,
		doLogin,
	}: { user: UserInfoResponse | null; doLogin: () => void }) => React.ReactNode;
}) {
	const { user, doLogin } = useStore(authStore);
	return children({ user, doLogin });
}
